// Payment utilities for Hassan Formations

export const STRIPE_PAYMENT_LINKS = {
  1: 'https://buy.stripe.com/test_bJe00i1BF9YwcF77z36kg00', // Prise de masse - €25
  2: 'https://buy.stripe.com/test_7sYbJ03JN9Yw0Wpf1v6kg01', // Sèche + Nutrition - €25
  3: 'https://buy.stripe.com/test_bJedR8eor9YwcF74mR6kg02'  // Entraînement militaire - €50
};

export const handleStripePayment = (formationId) => {
  const paymentLink = STRIPE_PAYMENT_LINKS[formationId];
  if (paymentLink) {
    window.open(paymentLink, '_blank');
    return { success: true };
  } else {
    return { success: false, error: 'Lien de paiement non trouvé' };
  }
};

export const formatPrice = (price) => {
  return new Intl.NumberFormat('fr-FR', {
    style: 'currency',
    currency: 'EUR'
  }).format(price);
};
